// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"06cd6fb1","41":"1670b893","631":"9945ba2d","653":"3c86ba0d","731":"610a2810","742":"e1121548","945":"6bbc7578","975":"a97a03c2"}[chunkId] + ".chunk.js";
};